import type {
  ConditionsSelectionContent,
  ConditionsSelectionInteractions,
} from 'commonTypes/api/scenarios/ConditionsSelection';
import type {
  TCreditSelectionScreenRules,
  TCreditSelectionScreenContent,
  TCreditSelectionScreenInteractions,
} from 'commonTypes/api/scenarios/CreditSelectionScreenContent';
import type {
  OfferDisbursementContent,
  OfferDisbursementInteractions,
} from 'commonTypes/api/scenarios/OfferDisbursement';

import type { BaseScenario, SCENARIO_STEP } from './BaseTypes';

/**
 * Дженерики дают уникальный обьект из content для кажого типа сценраия
 */
export type StepOfType<T extends SCENARIO_STEP> = Extract<IScenario, { step: T }>;
export type ContentOfType<T extends SCENARIO_STEP> = StepOfType<T>['content'];

export const getParticularStepContent = <T extends SCENARIO_STEP = SCENARIO_STEP>(
  stepData: IScenario | undefined | null,
  step: T,
): ContentOfType<T> | null => {
  return stepData?.step === step ? (stepData?.content as unknown as ContentOfType<T>) : null;
};

export type IScenario =
  | BaseScenario<
      SCENARIO_STEP.CONDITIONS_SELECTION,
      ConditionsSelectionContent,
      ConditionsSelectionInteractions,
      unknown
    >
  | BaseScenario<SCENARIO_STEP.CREDIT_OFFERS_LOADING, unknown, unknown, unknown>
  | BaseScenario<
      SCENARIO_STEP.CREDIT_SELECTION,
      TCreditSelectionScreenContent,
      TCreditSelectionScreenInteractions,
      TCreditSelectionScreenRules
    >
  | BaseScenario<SCENARIO_STEP.OFFER_DISBURSEMENT, OfferDisbursementContent, OfferDisbursementInteractions, unknown>
  | BaseScenario<SCENARIO_STEP.GO_TO_LEADGEN, unknown, unknown, unknown>;

export type INextScenarioResponse = IScenario;
